import React, {
  Children,
  Component,
  PropTypes,
  cloneElement,
} from 'react';
import scriptLoader from 'react-async-script-loader';

class CloudSponge extends Component {
  static defaultProps = {
    browserContactCacheMin: 0,
    css: null,
    csvProviders: {},
    displaySelectAllNone: true,
    ignoreMultipleEmails: false,
    include: ['name', 'email'],
    initiallySelectedContacts: false,
    inlineOauth: true,
    lazyLoad: false,
    onlyGroupedContacts: false,
    rootNodeSelector: 'body',
    selectAccount: false,
    skipSourceMenu: false,
    sources: ['gmail', 'yahoo', 'windowslive', 'aol'],
    zIndex: 90000,
    afterInit: () => {},
    beforeLaunch: () => {},
    afterLaunch: () => {},
    beforeImport: () => {},
    afterImport: () => {},
    beforeDisplayContacts: () => {},
    afterSubmitContacts: () => {},
    beforeClosing: () => {},
    afterClosing: () => {},
  };
  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.onScriptLoaded();
    }
  }
  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed) {
        this.onScriptLoaded();
      } else {
        this.onScriptError();
      }
    }
  }
  onScriptError() {
    console.error('There was an issue loading the script'); // eslint-disable-line no-console
  }
  onScriptLoaded() {
    const {
      browserContactCacheMin,
      css,
      csvProviders,
      displaySelectAllNone,
      filter,
      ignoreMultipleEmails,
      include,
      initiallySelectedContacts,
      inlineOauth,
      lazyLoad,
      locale,
      localeData,
      onlyGroupedContacts,
      rootNodeSelector,
      selectAccount,
      selectionLimit,
      selectionLimitMessage,
      skipSourceMenu,
      sources,
      zIndex,
      afterInit,
      beforeLaunch,
      afterLaunch,
      beforeImport,
      afterImport,
      beforeDisplayContacts,
      afterSubmitContacts,
      beforeClosing,
      afterClosing,
      webhook,
    } = this.props;

    // this is where you can configure the behavior and style of the widget
    // http://www.cloudsponge.com/developer/#the-contact-importer-widget
    window.cloudsponge.init({
      browserContactCacheMin,
      css,
      csvProviders,
      displaySelectAllNone,
      filter,
      ignoreMultipleEmails,
      include,
      initiallySelectedContacts,
      inlineOauth,
      lazyLoad,
      locale,
      localeData,
      onlyGroupedContacts,
      rootNodeSelector,
      selectAccount,
      selectionLimit,
      selectionLimitMessage,
      skipSourceMenu,
      sources,
      zIndex,
      afterInit,
      beforeLaunch,
      afterLaunch,
      beforeImport,
      afterImport,
      beforeDisplayContacts,
      afterSubmitContacts,
      beforeClosing,
      afterClosing,
      webhooks: { afterSubmitContacts: webhook },
    });
  }

  render() {
    const {
      children,
      childStyle,
      style,
    } = this.props;

    if (!children) return <a className="cloudsponge-launch">Add from Address Book</a>;

    const nestedChildren = Children.map(children, (child, key) => {
      return (
        <li style={childStyle}>
          { cloneElement(child,
            { key,
              className: 'cloudsponge-launch',
              'data-cloudsponge-source': child.props.source,
            })
          }
        </li>
      );
    });

    return (
      <ul style={style}>{nestedChildren}</ul>
    );
  }
}

CloudSponge.propTypes = {
  /* Component Props */
  children: PropTypes.node,
  childStyle: PropTypes.object,
  style: PropTypes.object,
  /* CloudSponge Props */
  browserContactCacheMin: PropTypes.number,
  css: PropTypes.string,
  csvProviders: PropTypes.object,
  displaySelectAllNone: PropTypes.bool,
  filter: PropTypes.func,
  ignoreMultipleEmails: PropTypes.bool,
  include: PropTypes.array,
  initiallySelectedContacts: PropTypes.bool,
  inlineOauth: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  locale: PropTypes.string,
  localeData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onlyGroupedContacts: PropTypes.bool,
  rootNodeSelector: PropTypes.string,
  selectAccount: PropTypes.bool,
  selectionLimit: PropTypes.number,
  selectionLimitMessage: PropTypes.string,
  skipSourceMenu: PropTypes.bool,
  sources: PropTypes.array,
  webhook: PropTypes.string,
  zIndex: PropTypes.number,
  /* CloudSponge Callbacks  */
  afterInit: PropTypes.func,
  beforeLaunch: PropTypes.func,
  afterLaunch: PropTypes.func,
  beforeImport: PropTypes.func,
  afterImport: PropTypes.func,
  beforeDisplayContacts: PropTypes.func,
  afterSubmitContacts: PropTypes.func,
  beforeClosing: PropTypes.func,
  afterClosing: PropTypes.func,
  /* ScriptLoader Props */
  isScriptLoaded: PropTypes.bool,
  isScriptLoadSucceed: PropTypes.bool,
};

export default scriptLoader('https://api.cloudsponge.com/widget/7bbd90a8ef013f3a46ca29f6e764c708a2327446.js')(CloudSponge);



// WEBPACK FOOTER //
// ./src/app/components/invite-contacts/cloudsponge.jsx